import { ErrorCodeType } from "application/models/IError";
import { ICashlessRepository } from "domains/cashless/interfaces/ICashlessRepository";
import { Kiosk } from "domains/kiosk/aggregates/Kiosk";
import { IOrder } from "modules/order/domain/models/IOrder";
import { IPedidoPosDTO } from "modules/order/domain/models/IPedidoPosDTO";
import { RechargeType } from "modules/order/presentation/UseOrderProvider";
import { TransactionType } from "modules/payment/domain/models/TransactionType";
import { GetError } from "utils/GetError";
import { v4 } from "uuid";

export interface ISyncOrderResult {
  message?: string;
  success?: boolean;
  pedidoPOS?: IPedidoPosDTO;
}

export const DoCashlessCosumeUseCase = async (
  cashlessRepository: ICashlessRepository,
  order: IOrder,
  transactionType: TransactionType,
  kiosk: Kiosk,
  recharge?: RechargeType
): Promise<ISyncOrderResult> => {
  let result: ISyncOrderResult = {};
  // Consumo pré cashless ou pós comanda
  if (
    transactionType === TransactionType.pospaid ||
    transactionType === TransactionType.cashless
  ) {
    try {
      const pedidoPOS = await cashlessRepository.sendCashlessConsumption(
        order,
        kiosk.localId,
        transactionType,
        order.payment?.FinancialTransactionModel,
        kiosk.id
      );
      result = {
        message: `Pedido sincronizado tag: ${
          pedidoPOS.clienteEstabelecimentoObject?.tag ?? "-"
        }`,
        success: true,
        pedidoPOS,
      };
      return result;
    } catch (error) {
      GetError(
        error,
        "DoCashlessCosumeUseCase",
        "DoCashlessCosumeUseCase",
        "Falha ao sincronizar pedido",
        ErrorCodeType.ORDER
      );
      result = {
        message: `${
          (error as any)?.response?.data?.message ??
          "Falha ao sincronizar o pedido"
        }`,
        success: false,
      };
      return result;
    }
  } else {
    // Pagamento de comanda
    if (recharge && recharge === "Payment") {
      try {
        await cashlessRepository.payAccount({
          accountId: order.customer?.associationId ?? "",
          amount: order.totalValue,
          discount: 0,
          discountOperator: "",
          discountReason: "",
          equipamentId: kiosk.id,
          equipmentName: kiosk.kioskName,
          installments: 1,
          localId: kiosk.localId,
          operatorId: null,
          operatorName: null,
          orderId: order.id,
          paymentId: v4(),
          paymentType: transactionType,
          serviceFeeEnabled: kiosk.serviceRate,
          success: true,
          transactionResponse:
            transactionType === TransactionType.pix
              ? JSON.stringify(order?.paymentPix)
              : JSON.stringify(order?.payment?.FinancialTransactionModel),
        });
        result = {
          message: "Pagamento sincronizado com sucesso",
          success: true,
        };
        return result;
      } catch (error) {
        GetError(
          error,
          "DoCashlessCosumeUseCase",
          "DoCashlessCosumeUseCase",
          "Falha ao sincronizar pedido",
          ErrorCodeType.GENERAL
        );

        result = {
          message: `Falha ao sincronizar pagamento`,
          success: false,
        };
        return result;
      }
    } else if (recharge && recharge === "Recharge") {
      // Recarga pré pago
      try {
        await cashlessRepository.rechargeAccount({
          localId: kiosk.localId,
          accountId: order.customer?.associationId ?? "",
          operatorId: null,
          equipamentId: kiosk.id,
          orderId: order.id,
          payments: [
            {
              amount: order.totalValue,
              discount: 0,
              installments: 1,
              paymentType: transactionType,
              transactionResponse:
                transactionType === TransactionType.pix
                  ? JSON.stringify(order?.paymentPix)
                  : JSON.stringify(order?.payment?.FinancialTransactionModel),
              success: true,
              hasDiscountInAmount: false,
            },
          ],
          meepUserId: "",
          rechargeMotive: "Recharga Totem",
          rechargeValue: order.totalValue,
        });
        result = {
          message: "Pagamento sincronizado com sucesso",
          success: true,
        };
        return result;
      } catch (error) {
        GetError(
          error,
          "DoCashlessCosumeUseCase",
          "DoCashlessCosumeUseCase",
          "Falha ao sincronizar pedido",
          ErrorCodeType.GENERAL
        );

        result = {
          message: `Falha ao sincronizar pagamento`,
          success: false,
        };
        return result;
      }
    } else {
      GetError(
        "Tipo de pagamento inválido",
        "DoCashlessCosumeUseCase",
        "DoCashlessCosumeUseCase",
        "Falha ao sincronizar pedido",
        ErrorCodeType.GENERAL
      );

      result = {
        message: `Falha na sincronização`,
        success: false,
      };
      return result;
    }
  }
};
